export default "__VITE_ASSET__1a352f6e__"